import React from "react";
import "./styles.scss";

import Button from "../../../common/button";
import Link from "../../../common/Link";
import { useNavigate } from "react-router-dom";
const ProductSolution = (props) => {
  const {
    bathroom_solutions,
    living_room_solutions,
    bedroom_solutions,
    step2,
  } = props;

  const navigate = useNavigate();
  const dataArray = [
    bathroom_solutions?.[0],
    bedroom_solutions?.[0],
    living_room_solutions?.[0],
  ];

  const handleNavigate = (
    layout_popup_description,
    layout_popup_title,
    taxonomy
  ) => {
    let data = {
      layout_popup_description,
      layout_popup_title,
      taxonomy,
    };
    sessionStorage.setItem("bundle_layout", JSON.stringify(data));
    navigate(`${process.env.REACT_APP_BASE}/layout`);
  };
  return (
    <div className="product-solution-container">
      <h4>{step2?.[0]?.title}<span>:</span></h4>
      {/* {step2?.[0]?.image !== "" ? (
        <div className="image">
          <img src={step2?.[0]?.image} alt="banner" />
        </div>
      ) : null} */}
      {step2?.[0]?.point_description?.length ||
      step2?.[0]?.sub_title_1 ||
      step2?.[0]?.sub_description_1 ? (
        <div className="section_a">
          <h3>{step2?.[0]?.sub_title_1}</h3>
          <p
            className="sub-description"
            dangerouslySetInnerHTML={{
              __html: step2?.[0]?.sub_description_1,
            }}
          />

          {step2?.[0]?.point_description?.map((item, index) => {
            let star = "*".repeat(index + 1);
            return (
              <div key={index}>
                <h2>
                  {star}
                  {item?.important_point}
                </h2>
                <p
                  className="description"
                  dangerouslySetInnerHTML={{
                    __html: item?.important_point_description,
                  }}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      <div className="section_b">
        {dataArray?.map((item, index) => {
          return (
            <>
              {item ? (
                <div key={index} className="sub-section_b">
                  <h3>{item?.title}</h3>
                  {item?.image ? (
                    <div className="image">
                      <img src={item?.image} alt="banner" />
                    </div>
                  ) : null}
                  <p
                    className="description"
                    dangerouslySetInnerHTML={{ __html: item?.description }}
                  />
                  {/* <Link url={"/layout"}> */}
                  <Button
                    onClick={() =>
                      handleNavigate(
                        item?.layout_popup_description,
                        item?.layout_popup_title,
                        item?.taxonomy
                      )
                    }
                  >
                    {item?.button_text}
                  </Button>
                  {/* </Link> */}
                </div>
              ) : null}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ProductSolution;
